import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as cookieNames from "../../booking/constants/Cookies"
import * as cookieHelper from "../../helpers/cookie"
import * as endpoints from "../../booking/constants/Endpoints"
import axios from "axios"
import * as date from "../../booking/helpers/date"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import { DateTime } from "luxon"

export default class FollowFlight extends Component {
  constructor(props) {
    super(props)

    this.state = {
      firstFlight: undefined,
      allFlights: [],
    }

    this.addEventListeners()
  }

  addEventListeners() {
    Emitter.on("*", (event) => this.handleEvent(event))
  }

  handleEvent(event) {
    const { type } = event
    switch (type) {
      case emits.REQUEST_FOLLOW_FLIGHT_COMPONENT:
        this.setFollowedFlightsToState()
        break
      default:
      // ignore
    }
  }

  componentDidMount() {
    this.setFollowedFlightsToState()
    window.addEventListener("scroll", this.handleScroll)
  }

  setFollowedFlightsToState = () => {
    const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    const followedFlights = this.getAndUpdateFollowedFlights()
    if (followedFlights) {
      const { firstFlight, flights } = followedFlights
      axios
        .get(endpoints.FLIGHT_INFO(hosts, firstFlight.id))
        .then((res) => res.data)
        .then((data) => {
          this.setState({ firstFlight: data })
        })
        .catch((err) => {
          console.log(err)
        })
      this.setState({ allFlights: flights })
    } else {
      this.setState({ firstFlight: undefined, allFlights: [] })
    }
  }

  getAndUpdateFollowedFlights() {
    let cookie = cookieHelper.getCookie(cookieNames.CPH_FOLLOW_FLIGHT)
    let flights = cookie
    let firstFlight

    const lang = document.body && document.body.dataset.language
    const dtLocale = date.luxonLocale(lang)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)

    if (cookie) {
      flights = flights.filter((f) => f.ept > currentTime.toJSDate().toISOString())
      if (flights.length > 0) {
        let sortedFlights = flights.sort((a, b) => (a.ept < b.ept ? -1 : a.ept > b.ept ? 1 : 0))
        flights = sortedFlights
        let lastFlight = flights[flights.length - 1]
        firstFlight = flights[0]
        let expiration = lastFlight.ept
        cookieHelper.setCookieWithExpiration(cookieNames.CPH_FOLLOW_FLIGHT, flights, expiration) //cookie will be set server side the next time the page loads
        return { firstFlight, flights }
      } else {
        cookieHelper.deleteCookie(cookieNames.CPH_FOLLOW_FLIGHT)
      }
    }
    return undefined
  }

  handleScroll = () => {
    let banner = document.querySelector(".js--follow-flight-module")
    if (banner) {
      let documentHeight = document.body.scrollHeight
      let currentScroll = window.scrollY + window.innerHeight
      if (currentScroll >= documentHeight) {
        banner.style.display = "none"
      } else {
        banner.style.display = ""
      }
    }
  }

  render() {
    const lang = document.body && document.body.dataset.language
    const departureLink =
      this.state.firstFlight?.direction === "D" && this.props.departuresPageLink
        ? `${this.props.departuresPageLink}/${this.state.firstFlight?.flightDisplayName}?id=${this.state.firstFlight?.flightId}`
        : undefined
    const arrivalLink =
      this.state.firstFlight?.direction === "A" && this.props.arrivalsPageLink
        ? `${this.props.arrivalsPageLink}/${this.state.firstFlight?.flightDisplayName}?id=${this.state.firstFlight?.flightId}`
        : undefined

    const dtLocale = date.luxonLocale(lang)
    const zone = "Europe/Copenhagen"
    const displayTime = DateTime.fromISO(this.state.firstFlight.displayTime).setLocale(dtLocale).setZone(zone)

    return this.state.firstFlight ? (
      <div className="follow-flight">
        <a href={this.state.firstFlight?.direction === "D" ? departureLink : arrivalLink}>
          <div className="follow-flight__flight">
            <Svg
              iconName={this.state.firstFlight.direction === "D" ? this.props.departureFlightIcon : this.props.arrivalFlightIcon}
              fillColor={this.props.flightIconColor}
            />
            <span className="flight-no">{this.state.firstFlight.flightDisplayName}</span>
            {this.state.firstFlight.direction === "D" ? (
              <span className="flight-destination">
                <span className="to-from-label"> {this.props.toLabel}</span> {this.state.firstFlight.destination}
              </span>
            ) : (
              <span className="flight-destination">
                <span className="to-from-label"> {this.props.fromLabel}</span> {this.state.firstFlight.destination}
              </span>
            )}
          </div>
          <div className={`follow-flight__departure`}>
            {this.props.expectedLabel}
            <span className="departure-time"> {displayTime.toFormat("HH:mm")}</span>
          </div>
          <div className="follow-flight__gate__info">{this.state.firstFlight.publicRemark || this.props.noStatusLabel}</div>
          {this.state.firstFlight.gate ? (
            <div className="follow-flight__gate__no">
              <span className="info-box">{this.state.firstFlight.gate}</span>
            </div>
          ) : (
            ""
          )}
        </a>
      </div>
    ) : (
      ""
    )
  }
}
